import { CmsApplianceDetailsAdditionalAppliancesPage } from '../../models/appliance-details-additional-appliances/cms-appliance-details-additional-appliances-page.interface';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsApplianceDetailsAdditionalAppliancesBenefitsPanel } from './cms-appliance-details-additional-appliances-benefits-panel.mock';

export const mockCmsApplianceDetailsAdditionalAppliancesPage: CmsApplianceDetailsAdditionalAppliancesPage =
  {
    ...mockCmsRegistrationRoot,
    applianceDetailsAdditionalAppliancesBenefitsPanel:
      mockCmsApplianceDetailsAdditionalAppliancesBenefitsPanel,
  };
